/* tslint:disable: no-duplicate-imports */
import { CategoryHierarchy, IProductRefinerHierarchy } from '@msdyn365-commerce/commerce-entities';
import { AsyncResult, SimpleProduct } from '@msdyn365-commerce/retail-proxy';
import { ISRPBreadcrumbState } from '../../actions/srp-breadcrumb-page.action';
import { INavigationMenuState } from '../../data-actions/navigation-menu-state';
import { IFullProductsSearchResultsWithCount, MappedSearchConfiguration } from './actions';
import { ListPageState } from './list-page-state';

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

export interface IMfrmSearchResultContainerData {
    products: AsyncResult<IFullProductsSearchResultsWithCount>;
    category: AsyncResult<CategoryHierarchy>;
    listPageState: AsyncResult<ListPageState>;
    categoryHierarchy: AsyncResult<CategoryHierarchy[]>;
    searchConfiguration: AsyncResult<MappedSearchConfiguration[]>;
    refiners: AsyncResult<IProductRefinerHierarchy[]>;
    featureProduct: AsyncResult<SimpleProduct>;
    navMenuState: AsyncResult<INavigationMenuState>;
    updateBreadcrumbOnSrp: AsyncResult<ISRPBreadcrumbState>;
    seoData: any;
}

/**
 * DisplayTemplate enum type.
 */
export const enum DisplayTemplate {
    /**
     * The List member.
     */
    List = 0,
    /**
     * The Slider member.
     */
    Slider = 1,
    /**
     * The SliderWithBars member.
     */
    SliderWithBars = 2,
    /**
     * The Range member.
     */
    Range = 3,
    /**
     * The TextBox member.
     */
    TextBox = 4
}

/**
 * AttributeDataType enum type.
 */
export const enum AttributeDataType {
    /**
     * The None member.
     */
    None = 0,
    /**
     * The Currency member.
     */
    Currency = 1,
    /**
     * The DateTime member.
     */
    DateTime = 2,
    /**
     * The Decimal member.
     */
    Decimal = 3,
    /**
     * The Integer member.
     */
    Integer = 4,
    /**
     * The Text member.
     */
    Text = 5,
    /**
     * The TrueFalse member.
     */
    TrueFalse = 6,
    /**
     * The Video member.
     */
    Video = 40,
    /**
     * The Image member.
     */
    Image = 41
}